module.exports = __webpack_public_path__ + "static/media/event-2.e5376644.jpg";